import { downloadJobSectionSnapshot, generateJobSectionSnapshot, isJobSectionSnapshotReady } from "api-operations/editor/editor";
import i18next from "i18next";
import EditorModule from "../EditorModule";
import SnapshotGenerationStartedModal from "./SnapshotGenerationStartedModal";
export default class SnapshotModule extends EditorModule {
    constructor(editor) {
        super(editor);
        this.moduleId = "SnapshotModule";
        this.snapshotGroup = document.createElement("div");
        this.generateSnapshotButton = document.createElement("button");
        this.snapshotSpinner = document.createElement("span");
        this.snapshotLabel = document.createElement("span");
        this.snapshotGenerationStartedModal = new SnapshotGenerationStartedModal();
        this.snapshotCheckInterval = null;
        this.generationRecentlyTriggered = false;
        editor.domNode.appendChild(this.snapshotGenerationStartedModal);
        this.snapshotGroup.classList.add("ui", "buttons");
        this.editor.sectionHeader.headerRow.insertBefore(this.snapshotGroup, this.editor.sectionHeader.finishBar);
        this.generateSnapshotButton.className = "ui button primary--light";
        this.snapshotSpinner.className = "snapshotSpinner";
        this.snapshotLabel.textContent = i18next.t("editor.snapshots.generateSnapshot");
        this.generateSnapshotButton.append(this.snapshotLabel, this.snapshotSpinner);
        this.generateSnapshotButton.addEventListener("click", this.generateSnapshot.bind(this));
        this.snapshotGroup.appendChild(this.generateSnapshotButton);
    }
    generateSnapshot() {
        const { assignmentId, section } = this.editor;
        if (!section || this.generateSnapshotButton.disabled)
            return;
        this.setGenerating(true);
        generateJobSectionSnapshot(assignmentId, section.id);
        this.snapshotGenerationStartedModal.open = true;
        this.generationRecentlyTriggered = true;
        this.startSnapshotInterval();
    }
    setGenerating(generating) {
        this.generateSnapshotButton.disabled = generating;
        this.generateSnapshotButton.classList.toggle("generating", generating);
        this.generateSnapshotButton.setAttribute("aria-busy", String(generating));
        this.snapshotLabel.textContent = i18next.t(generating
            ? "editor.snapshots.generatingSnapshot"
            : "editor.snapshots.generateSnapshot");
    }
    startSnapshotInterval() {
        this.clearSnapshotInterval();
        this.snapshotCheckInterval = window.setInterval(this.checkSnapshot.bind(this), 3000);
    }
    clearSnapshotInterval() {
        this.snapshotCheckInterval && window.clearInterval(this.snapshotCheckInterval);
    }
    async checkSnapshot() {
        const { assignmentId, section } = this.editor;
        if (!section)
            return;
        try {
            if (await isJobSectionSnapshotReady(assignmentId, section.id)) {
                this.clearSnapshotInterval();
                this.setGenerating(false);
                if (this.generationRecentlyTriggered) {
                    downloadJobSectionSnapshot(assignmentId, section.id, section.name);
                }
            }
        }
        catch (_a) {
            // 404 while the new snapshot row does not exist yet. Keep the button disabled and poll again.
        }
    }
    downloadSnapshot() {
        const { assignmentId, section } = this.editor;
        if (!section)
            return;
        downloadJobSectionSnapshot(assignmentId, section.id, section.name);
    }
    unload() {
        this.clearSnapshotInterval();
        this.snapshotGenerationStartedModal.remove();
        this.snapshotGroup.remove();
    }
}
